"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSelectValue = exports.useSelectField = void 0;

var _useFormField = require("./useFormField");

var useSelectField = function useSelectField(state, dispatch) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fieldProps = (0, _useFormField.useFormField)(state, dispatch, args);
  fieldProps.props.options = args.options;
  return fieldProps;
};

exports.useSelectField = useSelectField;
var defaultSelectValue = '';
exports.defaultSelectValue = defaultSelectValue;